import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const data = [
  { key: 1, plant: "Зерно", count: 1035023 },
  { key: 2, plant: "Хлопок", count: 74694 },
  { key: 3, plant: "Табак", count: 1149 },
  { key: 4, plant: "Картофель", count: 747591 },
  { key: 5, plant: "Овощи", count: 757756 },
  { key: 6, plant: "Культуры", count: 190358 },
  { key: 7, plant: "Виноград", count: 4523 },
  { key: 8, plant: "Бахчи", count: 198757 },
];

const PlantBarChart = () => {
  return (
    <ResponsiveContainer width="70%" height={400}>
      <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="plant" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="count" fill="#8884d8" name="Количество" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default PlantBarChart;
